// src/components/StepperDialog.tsx

// IGNORE CONTENS HERE, SEE Contract FOR BETTER FORM EXAMPLE
import {
    DialogTitle,
    DialogContent,
} from '@mui/material';
import { AddNewMemberDialogContent } from './AddNewMemberDialogContent';
import DialogWithClose from '../../../components/DialogWithClose';
import { IMember } from '../../../interfaces/Member.interface';





const AddNewMemberDialog = ({ open, onClose }: { open: boolean, onClose: (updatedMember?: IMember) => void }) => {

    const handleFinish = (updatedMember?: IMember) => {
        onClose(updatedMember);
    };


    return (

        <DialogWithClose maxWidth={'md'} fullWidth open={open} onClose={onClose}>

            <DialogTitle>Add New Member</DialogTitle>
        
            <DialogContent className="mr-4">
                <AddNewMemberDialogContent handleFinish={handleFinish} prevData={{}} />
            </DialogContent>

        </DialogWithClose>

    );
};

export default AddNewMemberDialog;
